(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sg-product-profile"] && !Shopify.designMode) return;
  try {
    const initializeSignalGravitySizeGuides = () => {
    document.querySelectorAll('[data-sg-size-guide-open]').forEach((button) => {
      if (button.dataset.sizeGuideReady === 'true') return;

      button.dataset.sizeGuideReady = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (dialog instanceof HTMLDialogElement) {
          dialog.showModal();
          document.documentElement.classList.add('sg-guide-open');
        }
      });
    });

    document.querySelectorAll('dialog.sg-size-guide').forEach((dialog) => {
      if (dialog.dataset.sizeGuideReady === 'true') return;

      dialog.dataset.sizeGuideReady = 'true';
      dialog.addEventListener('close', () => document.documentElement.classList.remove('sg-guide-open'));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  };

  const signalGravityJourneyPrice = (details, profile) => {
    const price = details.querySelector('product-price .price');
    const text = price?.textContent?.replace(/\s+/g, ' ').trim();
    return text || profile.dataset.initialPrice || '';
  };

  const signalGravityJourneyInputs = (details) =>
    Array.from(details.querySelectorAll('variant-picker [data-option-name]')).filter(
      (input) => input.dataset.optionName?.toLowerCase() === 'size'
    );

  const syncSignalGravityProductJourney = (details) => {
    if (!(details instanceof HTMLElement)) return;

    const profile = details.querySelector('.sg-product-profile');
    if (!(profile instanceof HTMLElement)) return;

    const sizeInputs = signalGravityJourneyInputs(details);
    const selectedSize = sizeInputs.find((input) => input.checked);
    const hasSizeChoice = sizeInputs.length === 0 || Boolean(selectedSize);
    const selectedSizeAvailable = !selectedSize || selectedSize.dataset.optionAvailable !== 'false';
    const sizeState = profile.querySelector('[data-sg-size-state]');
    const addToCart = details.querySelector('.add-to-cart-button');

    profile.dataset.sizeReady = String(hasSizeChoice);

    if (sizeState) {
      sizeState.textContent = selectedSize?.value || profile.dataset.sizePrompt || 'Select a size';
    }

    if (!(addToCart instanceof HTMLButtonElement)) return;

    addToCart.classList.add('sg-journey-cta');
    Array.from(addToCart.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = '';
      }
    });
    let content = addToCart.querySelector('.sg-journey-cta__content');

    if (!content) {
      content = document.createElement('span');
      content.className = 'sg-journey-cta__content';

      const label = document.createElement('span');
      label.className = 'sg-journey-cta__label';
      content.append(label);

      const price = document.createElement('span');
      price.className = 'sg-journey-cta__price';
      content.append(price);

      addToCart.insertBefore(content, addToCart.querySelector('.add-to-cart__added'));
    }

    const label = content.querySelector('.sg-journey-cta__label');
    const price = content.querySelector('.sg-journey-cta__price');
    const labelText = hasSizeChoice
      ? profile.dataset.addLabel || 'Add to cart'
      : profile.dataset.sizePrompt || 'Select a size';
    const priceText = signalGravityJourneyPrice(details, profile);

    if (label) label.textContent = labelText;
    if (price) price.textContent = priceText;

    addToCart.disabled = !hasSizeChoice || !selectedSizeAvailable;
    addToCart.setAttribute('aria-label', [labelText, priceText].filter(Boolean).join(' '));
    details.dispatchEvent(new CustomEvent('sg:purchase-state', { bubbles: true }));
  };

  const initializeSignalGravityProductJourneys = () => {
    document.querySelectorAll('.product-details:has(.sg-product-profile)').forEach((details) => {
      const profile = details.querySelector('.sg-product-profile');
      if (!(profile instanceof HTMLElement)) return;

      if (profile.dataset.journeyInitialized !== 'true') {
        profile.dataset.journeyInitialized = 'true';
        signalGravityJourneyInputs(details).forEach((input) => {
          input.checked = false;
          input.dataset.currentChecked = 'false';
        });
      }

      syncSignalGravityProductJourney(details);
    });
  };

  initializeSignalGravitySizeGuides();
  initializeSignalGravityProductJourneys();
  document.addEventListener('shopify:section:load', initializeSignalGravitySizeGuides);
  document.addEventListener('shopify:section:load', initializeSignalGravityProductJourneys);

  if (!document.documentElement.hasAttribute('data-sg-product-journey-listening')) {
    document.documentElement.setAttribute('data-sg-product-journey-listening', 'true');
    document.addEventListener('change', (event) => {
      const input = event.target.closest?.('variant-picker [data-option-name]');
      if (!input || input.dataset.optionName?.toLowerCase() !== 'size') return;

      [0, 120, 360].forEach((delay) => {
        window.setTimeout(() => {
          document.querySelectorAll('.product-details:has(.sg-product-profile)').forEach(
            syncSignalGravityProductJourney
          );
        }, delay);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
